import React, { RefObject } from "react";
import { FormattedMessage } from "react-intl";

import { BaseError } from "@apps/mf-overview/src/ts/components/errors/BaseError";

/**
 * Error message that'll be displayed if an unhandled exception is thrown while
 * rendering the application
 */
// tslint:disable-next-line variable-name
export const ClientError = (props: { ref?: RefObject<HTMLDivElement | null>}) => {
    const errorMessage = (
        <FormattedMessage
            id="ErrorMessages__ClientError"
            defaultMessage="Der opstod en fejl. Prøv at genindlæse siden om lidt."
        />
    );

    return <BaseError ref={props.ref} errorMessage={ errorMessage } />;
};
